'use strict';

var ACTION_TYPES = require('./actionTypes');

var actionCreators = {
  /**
   * Fires when a category is changed on the product edit page.
   *
   * @param categoryId
   * @returns {{type: string, payload: {categoryId: int}}}
   */
  categoryChanged: function categoryChanged(categoryId) {
    return {
      type: ACTION_TYPES.CATEGORY_CHANGED,
      payload: {
        categoryId: categoryId
      }
    };
  },

  /**
   * Fires when a variant is selected or deselected on the product edit page.
   *
   * @param variantSelected
   * @returns {{type: string, payload: {variantSelected: int}}}
   */
  variantChanged: function variantChoiceSelected(variantSelected) {
    return {
      type: ACTION_TYPES.VARIANT_CHANGED,
      payload: {
        variantSelected: variantSelected
      }
    };
  },


  /**
   * Fires when tags have changed and there has been a match.
   *
   * @param licenseId int
   * @returns {{type: string, payload: {licenseId: int}}}
   */
  tagsChanged: function tagsChanged(licenseId) {
    return {
      type: ACTION_TYPES.TAGS_CHANGED,
      payload: {
        licenseId:  licenseId
      }
    };
  }

};

module.exports = actionCreators;
